import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest, HttpResponse } from '@angular/common/http';
import { StudentAuthService } from '../../modules/student/services/student-auth.service';
import { inject } from '@angular/core';
import { BehaviorSubject, catchError, filter, map, Observable, switchMap, take, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { SnackbarService } from '../services/snackbar-service';


let isRefreshing = false;
// null = refresh chal raha hai, '' = refresh fail, string = naya token
const refreshTokenSubject = new BehaviorSubject<string | null>(null);
const NETWORK_ERROR_MESSAGE = 'Network error. Please check your connection.';
let networkErrorShown = false;

function addToken(req: HttpRequest<unknown>, token: string | null): HttpRequest<unknown> {
  return token
    ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } })
    : req;
}

function isTokenExpired(body: any, status?: number): boolean {
  // console.log('isTokenExpired check:', { body, status });
  return body?.message === 'TOKEN_EXPIRED' || body?.message === 'EMPTY_TOKEN' || status === 401 || status === 403;
}

function isNetworkError(error: any): boolean {
  return error instanceof HttpErrorResponse && error.status === 0;
}

// status 0 par message dikhao, logout NAHI
function toNetworkError(error: HttpErrorResponse): HttpErrorResponse {
  return new HttpErrorResponse({
    error: { message: NETWORK_ERROR_MESSAGE },
    status: 0,
    statusText: NETWORK_ERROR_MESSAGE,
    url: error.url ?? undefined,
  });
}

function showNetworkError(_snackbarService: SnackbarService): void {
  if (networkErrorShown) return;
  networkErrorShown = true;
  // _snackbarService.error('Network error. Please check your connection.');
  _snackbarService.error(NETWORK_ERROR_MESSAGE);
  setTimeout(() => (networkErrorShown = false), 3000);
}


// Logout + LOGIN page par redirect
function logout(router: Router): void {
  const lang = localStorage.getItem('selectedLanguage') || 'en';
  localStorage.clear();
  localStorage.setItem('selectedLanguage', lang);

  // Multiple requests fail hone par baar-baar navigate na ho
  if (!router.url.includes('/LOGIN')) {
    router.navigate(['/', lang, 'LOGIN']);
  }
}


export const authInterceptor: HttpInterceptorFn = (req, next) => {
    console.log("interceptor req-data -01: ", req);
    const _studentAuthService = inject(StudentAuthService);
    const router = inject(Router);
    const _snackbarService = inject(SnackbarService);  
    

    // Refresh API ko interceptor se skip karo
    if (req.url.includes('/gAT')) {
        return next(req);
    }

    // 1. Har request mein access token lagao
  const authReq = addToken(req, localStorage.getItem('accessToken'));

  return next(authReq).pipe(
    // 2. Agar HTTP 200 aaya par body mein TOKEN_EXPIRED hai, toh use error bana do
    map((event: HttpEvent<unknown>) => {
      if (event instanceof HttpResponse && isTokenExpired(event.body)) {
        throw new HttpErrorResponse({
          error: event.body, status: 403, url: req.url ?? undefined
        });
      }
      return event;
    }),
    // 3. Token expire hua toh refresh karo
    catchError((error: HttpErrorResponse) => {
      console.log('AUTH INTERCEPTOR ERROR:', { url: req.url, status: error.status, error: error.error });
      // status 0: sirf message, na refresh na logout
      if (isNetworkError(error)) {
        showNetworkError(_snackbarService);
        // return throwError(() => error);
        return throwError(() => toNetworkError(error));
      }

      if (isTokenExpired(error.error, error.status)) {
        return handleRefresh(req, next, _studentAuthService, router, _snackbarService);
      }
      return throwError(() => error);
    })
  );
};

function handleRefresh(req: HttpRequest<unknown>, next: HttpHandlerFn, authService: StudentAuthService, router: Router, _snackbarService: SnackbarService): Observable<HttpEvent<unknown>> {
  // Agar refresh pehle se chal raha hai, toh naye token ka wait karo
  if (isRefreshing) {
    return refreshTokenSubject.pipe(
      filter(token => token !== null),
      take(1),
      switchMap(token => token
        ? next(addToken(req, token))
        : throwError(() => new Error('Session expired')))
    );
  }

  const refreshToken = localStorage.getItem('refreshToken');
  const userId = localStorage.getItem('userId');

  if (!refreshToken || !userId) {
    logout(router);
    return throwError(() => new Error('No refresh token'));
  }

  isRefreshing = true;
  refreshTokenSubject.next(null);

  return authService.getAccessToken({ refreshToken, garbage: userId }).pipe(
    switchMap((response: any) => {
      console.log('REFRESH TOKEN RESPONSE:', response);
      const newAccessToken = response?.data?.accessToken;

      if (!newAccessToken) {
        throw new Error('The refresh API did not return a token.');
      }

      localStorage.setItem('accessToken', newAccessToken);
      if (response?.data?.refreshToken) {
        localStorage.setItem('refreshToken', response.data.refreshToken);
      }

      isRefreshing = false;
      refreshTokenSubject.next(newAccessToken);

      // Original request naye token ke saath retry
      return next(addToken(req, newAccessToken));
    }),
    catchError(err => {
      isRefreshing = false;
      refreshTokenSubject.next(''); // waiting requests ko fail signal

      if (isNetworkError(err)) {
        showNetworkError(_snackbarService);
        // return throwError(() => err);
        return throwError(() => toNetworkError(err));
      }

      logout(router);
      return throwError(() => err);
    })
  );
};